/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
export const StarIcon = ({ full, scale, partial }) => (h("calcite-icon", { class: partial ? undefined : "icon", icon: full ? "star-f" : "star", scale: scale }));
//# sourceMappingURL=star.js.map
